module.exports = __webpack_public_path__ + "assets/img/people.bef9dd08.png";